;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('sidebarSecondLevelMenu', sidebarSecondLevelMenu)

  /* @ngInject */
  function sidebarSecondLevelMenu ($rootScope) {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: '/core/directives/sidebar-second-level-menu/sidebar-second-level-menu-directive.html?$$REVISION$$',
      link: function ($scope) {
        $rootScope.isSecondLevelSidebarExpanded = true

        $scope.openSidebarMobile = function () {
          $('.sidebar-menu-second-level').transition('slide down')
        }

        $scope.closeSidebarMobile = function () {
          $('.sidebar-menu-second-level').transition('slide down')
        }

        $scope.toggleCollapseSecondLevelMenu = function () {
          $rootScope.isSecondLevelSidebarExpanded = !$rootScope.isSecondLevelSidebarExpanded
        }
      }
    }
  }
})()
